import { useState } from "react"
import { format } from "date-fns"
import { CalendarIcon, Search, X } from "lucide-react"

import { Button } from "components/ui/button_v3"
import { Calendar } from "components/ui/calendar_v2"
import { Input } from "components/ui/input_v3"
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover_v2"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "components/ui/select_v4"
import { FILE_TYPE_OPTIONS } from "services/utils"
import { cn } from "lib/utils"
import localization from "services/localization"

export function ResourceFilters({
  searchQuery,
  onSearchChange,
  fileTypeFilter,
  onFileTypeChange,
  dateRange,
  onDateRangeChange,
  theme,
}) {
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const hasActiveFilters = searchQuery || fileTypeFilter !== "all" || dateRange

    const select_bg =
    theme === "dark"
      ? "bg-[var(--card-bg)] text-white border-border"
      : "bg-card text-foreground border-border";

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      <div className={"relative flex-1 min-w-0"}>
        <Search
  className={cn(
    "absolute left-3 top-1/2 -translate-y-1/2 size-4",
    theme === "dark" ? "text-white" : "text-black"
  )}
/>
        <Input
          placeholder="Search by file name..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          theme={theme}
          className="pl-9"
        />
      </div>

      <Select value={fileTypeFilter} onValueChange={onFileTypeChange}>
        <SelectTrigger className={cn("w-full sm:w-[180px]", select_bg)}>
          <SelectValue placeholder="File type" />
        </SelectTrigger>
        <SelectContent theme={theme}>
          {FILE_TYPE_OPTIONS.map((opt) => (
            <SelectItem key={opt.value} value={opt.value} theme={theme}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

           <Popover open={datePickerOpen} onOpenChange={setDatePickerOpen}>
                     <PopoverTrigger asChild>
                      <Button
            variant="outline"
            className={cn(
              "w-full sm:w-[240px] justify-start text-left font-normal",
              !dateRange && "text-muted-foreground",
              select_bg
            )}
          >
                          <CalendarIcon className="size-4" />
            {dateRange?.from ? (
              dateRange.to ? (
                <>
                  {format(dateRange.from, "LLL dd")} -{" "}
                  {format(dateRange.to, "LLL dd, y")}
                </>
              ) : (
                format(dateRange.from, "LLL dd, y")
              )
            ) : (
              <span>{localization.date_range || "Date range"} </span>
            )}
          </Button>
                     </PopoverTrigger>
       <PopoverContent className="w-auto p-2" theme={theme}
        onPointerDownOutside={(e) => e.preventDefault()}
  onInteractOutside={(e) => e.preventDefault()}
       >
       <div className={`rounded-md p-3 ${theme === 'dark' ? 'bg-[#1e1e2e]' : 'bg-white'}`}>
       
                       <Calendar
                       theme={theme}
                         initialFocus
                         mode="range"
                        defaultMonth={dateRange?.from}
                         selected={dateRange}
                         onSelect={onDateRangeChange}
                         numberOfMonths={2}
                       />
                       </div>
                     </PopoverContent>
                   </Popover>

      {hasActiveFilters && (
        <Button
          variant="ghost"
          size="icon"
          onClick={() => {
            onSearchChange("")
            onFileTypeChange("all")
            onDateRangeChange(undefined)
          }}
          className="shrink-0"
          aria-label="Clear all filters"
        >
          <X className="size-4" />
        </Button>
      )}
    </div>
  )
}
